import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rollup-builder"
}
const _hoisted_2 = { class: "text-caption text-medium-emphasis mb-2" }
const _hoisted_3 = { class: "d-flex justify-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_ctx.relationships.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.open)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              variant: "text",
              size: "small",
              "prepend-icon": "mdi-auto-fix",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$tt('formula-rollup.open')), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_sheet, {
              key: 1,
              border: "",
              rounded: "",
              class: "pa-3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$tt('formula-rollup.hint')), 1),
                _createVNode(_component_v_row, {
                  dense: "",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          label: _ctx.$tt('formula-rollup.relationship'),
                          items: _ctx.relationships,
                          modelValue: _ctx.relationshipAlias,
                          "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.relationshipAlias) = $event)),
                            _ctx.onRelationship
                          ],
                          density: "compact",
                          "hide-details": ""
                        }, null, 8, ["label", "items", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    (_ctx.relationship)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "12",
                          sm: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              label: _ctx.$tt('formula-rollup.field'),
                              items: _ctx.fields,
                              modelValue: _ctx.fieldAlias,
                              "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fieldAlias) = $event)),
                                _ctx.onField
                              ],
                              density: "compact",
                              "hide-details": "",
                              clearable: _ctx.isList
                            }, null, 8, ["label", "items", "modelValue", "clearable", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.relationship && _ctx.isList)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: "12",
                          sm: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              label: _ctx.$tt('formula-rollup.aggregation'),
                              items: _ctx.aggregations,
                              modelValue: _ctx.aggregation,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.aggregation) = $event)),
                              density: "compact",
                              "hide-details": ""
                            }, null, 8, ["label", "items", "modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.open = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$tt('cancel')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "flat",
                    disabled: !_ctx.built,
                    onClick: _ctx.apply
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$tt('formula-rollup.apply')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ])
              ]),
              _: 1
            }))
      ]))
    : _createCommentVNode("", true)
}